import React, {useState} from 'react';

const useHover = () => {
    const [isHovered, setIsHover] = useState(false);
    return {
        isHovered,
        hoverParentProps: {
            onMouseEnter: () => setIsHover(true),
            onMouseLeave: () => setIsHover(false)
        }
    };
};

export default useHover;